// The site answers on more than one domain (itorgo.kg, and itorgo.com as a
// fallback when .kg DNS is down), so links between the storefront and the
// admin panel are built from the domain the visitor is actually on — never
// a hardcoded one that may not resolve right now.

// "itorgo.kg" for itorgo.kg / www.itorgo.kg / admin.itorgo.kg, same for .com.
export function siteRootDomain(host: string = typeof window !== 'undefined' ? window.location.hostname : ''): string {
  return host.replace(/^(www|admin)\./, '')
}

export function adminPanelUrl(): string {
  if (typeof window === 'undefined') return 'https://admin.itorgo.kg'
  const { hostname, protocol } = window.location
  if (hostname === 'localhost' || hostname === '127.0.0.1') return `${protocol}//admin.localhost:5174`
  return `${protocol}//admin.${siteRootDomain(hostname)}`
}

// Parent-domain cookie so a language choice is shared between the storefront
// and the admin panel of the same domain. Empty on localhost / IPs.
export function sharedCookieDomain(host: string = typeof window !== 'undefined' ? window.location.hostname : ''): string {
  if (!/(^|\.)itorgo\.(kg|com)$/.test(host)) return ''
  return `; domain=.${siteRootDomain(host)}`
}
